import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ROLE_HOME: Record<string, string> = {
  SUPER_ADMIN: '/super-admin/dashboard',
  COMPANY_ADMIN: '/company-admin/dashboard',
  DISPATCH_AGENT: '/dispatch/dashboard',
  RECOVERY_OFFICER: '/recovery/dashboard',
  COMPANY_AGENT: '/agent/dashboard',
  INDEPENDENT_USER: '/user/dashboard',
  TRANSPORTER: '/transporter/dashboard',
};

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredRoles }) => {
  const { isAuthenticated, user, isLoading } = useAuth();

  if (isLoading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles && user && !requiredRoles.includes(user.role)) {
    return <Navigate to={ROLE_HOME[user.role] ?? '/unauthorized'} replace />;
  }

  return <>{children}</>;
};
